import React from 'react';

import { DiscountStatus, PagePath, PriceSymbol, ProductStatus } from '@/layouts/shared';
import { checkTime, createHandle, toMoney } from '@/libs/app';
import { Link, Image, PentagonIcon } from '@/components';
import { TFunction } from 'next-i18next';
import NewGallery from '@/components/ui/NewGallery';
import { IRelatedProduct } from '../layout';

type ProductLoopProps = {
  p: IRelatedProduct;
  t: TFunction;
};
export const ProductLoop = (props: ProductLoopProps) => {
  const { p, t } = props;
  let handle = `${createHandle(p.product_name)}-${p.id}-${p.product_code}`;
  let isDiscount = p.product_discount ? checkTime(p.product_discount?.started_at, p.product_discount?.ended_at) : false;
  if (p.product_discount && p.product_discount?.status === DiscountStatus.Ended) isDiscount = false;
  const isDeposited = p.quantity <= 0 || p.status == ProductStatus.CloseASale || p.status === ProductStatus.Deposited;
  return (
    <div className="tw-w-full tw-h-full">
      <div className="tw-flex tw-flex-col tw-rounded-5 tw-border tw-border-gray-70 tw-overflow-hidden tw-w-full tw-h-full hover:tw-border-primary-main tw-duration-500 tw-ease-linear">
        <div className="tw-w-full p-100p tw-relative tw-leading-0 tw-h-0 tw-bg-secondary-20">
          {p.images && p.images.length > 1 ? (
            <div className="tw-w-full tw-h-full !tw-absolute tw-z-1 tw-top-0 tw-left-0 tw-bottom-0">
              <NewGallery images={p.images} />
            </div>
          ) : (
            <Image
              className="tw-w-full tw-h-full !tw-absolute tw-z-1 tw-top-0 tw-left-0 tw-bottom-0"
              alt={p.product_name}
              src={p.images && p.images[0] ? p.images[0].url : ''}
            ></Image>
          )}
          {p.product_discount && isDiscount && (
            <>
              <div className="tw-w-7 tw-h-7 tw-absolute tw-top-3 tw-right-3 tw-z-10">
                <Image src="/sale.png" className="tw-w-full tw-h-full" alt="sale"></Image>
              </div>
            </>
          )}
          {isDeposited && (
            <div
              className="tw-absolute tw-z-10"
              style={{
                top: '8px',
                left: '0',
              }}
            >
              <PentagonIcon text={t('detail.label.soldOut')} />{' '}
            </div>
          )}
        </div>

        <div className="tw-pt-4 tw-pb-5">
          <Link
            url={{ pathname: PagePath.ProductDetailPage, query: { id: handle } }}
            className="tw-h-12 md:tw-h-12 tw-px-1 tw-text-base  tw-font-semibold tw-text-primary-main tw-w-full tw-line-clamp-2 tw-text-center"
          >
            {p.product_name}
          </Link>
          <div className="tw-text-center">
            <div className="tw-text-secondary-81 tw-font-light tw-text-sm md:tw-text-base tw-line-clamp-1 tw-px-1">
              {p.product_code}
            </div>
            {p.quotation ? (
              <span className="tw-text-secondary-70">{t('product:detail.label.contact')}</span>
            ) : (
              <>
                {p.product_discount && isDiscount ? (
                  <>
                    <span className="tw-text-md tw-block tw-mt-1 tw-text-secondary-70 tw-font-semibold">
                      {toMoney(p.price - (p.price * p.product_discount.discount) / 100, t, PriceSymbol.$)}
                    </span>
                  </>
                ) : (
                  <>
                    <span className="tw-text-md tw-block tw-mt-1 tw-text-secondary-70 tw-font-semibold">
                      {toMoney(p.price, t, PriceSymbol.$)}
                    </span>
                  </>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
